import React, { useContext, useState } from "react"
import { withStyles, createStyles } from "@material-ui/core/styles"
import { Container, Typography, Snackbar } from "@material-ui/core"
import { message as closeMessage } from "context/commons/actions"
import { I18nContext } from "translations"
import { useStateValue } from "context/store"
import { sendPQRS, checkGuideNumber } from "context/landings/actions"
import LayoutLanding from "components/Landing/Layouts"
import ContactForm from "components/Landing/Form/ContactForm"
import GuideNumberCheckForm from "components/Landing/Form/GuideNumberCheckForm"
import Loading from "components/Loading"
import { modalMessageHtml } from "utils"


const styles = createStyles(() => ({
  pqrs: {
    marginTop: "68px",
    padding: "60px 10px",
    textAlign: "justify",
  },
}))

function Pqrs({ classes }) {
  const { translate } = useContext(I18nContext)
  const [resetGuideNumber, setResetGuideNumber] = useState(false)
  const [isGuideValid, setIsGuideValid] = useState(false)
  const [loadingGuideNumber, setLoadingGuideNumber] = useState(false)
  const [guideNumber, setGuideNumber] = useState("")
  const [
    {
      commons: { loading, message },
    },
    dispatch,
  ] = useStateValue()

  const onSubmit = async (values) => {
    const callback = await sendPQRS(dispatch, {...values, package_id: guideNumber })
    if (callback.status) {
      setResetGuideNumber(true)
      setIsGuideValid(false)
    }
  }

  const onSubmitGuideCheck = async (values) => {
    setLoadingGuideNumber(true);
    if (!values?.guide_number) {
      invalidGuideNumberModal()
    }

    const callback = await checkGuideNumber(dispatch, values.guide_number)
    setIsGuideValid(callback.status)
    if (!callback.status) {
      invalidGuideNumberModal()
      setLoadingGuideNumber(false)
    }
    setGuideNumber(values?.guide_number)
    callback.status && setLoadingGuideNumber(false)
  }

  const invalidGuideNumberModal = () =>
    modalMessageHtml(
      "",
      `<div style="width: 100%;">
        <div style="padding: 20px; position: relative">
            <h3 style="color: #B534B5; font-weight: bold; font-size: large; margin-top: 0; text-align: justify">
              ${translate("app.guide.incorrectGuideMessage")}
            </h3>

            <p style="color: #666;margin-bottom: 20px; line-height: 1.5; font-size: medium; text-align: justify;">
              ${translate("app.guide.explanatoryText")}
            </p>

            <ul style="padding-left: 20px; margin: 15px 0; font-size: medium; text-align: justify;">
                <li style="margin-bottom: 10px; line-height: 1.5;">
                    <span style="font-weight: bold;">${translate("app.guide.corporateUser")}:</span> ${translate("app.guide.enterWebpage")}
                </li>
                <li style="line-height: 1.5;">
                    <span style="font-weight: bold;">${translate("app.guide.massUser")}:</span> ${translate("app.guide.enterCentralChat")}
                </li>
            </ul>

            <p style="margin-top: 30px;color: #666; font-size: medium; text-align: justify;">
                ${translate("app.guide.thankYou")}
            </p>
        </div>
        <div style="padding: 5px; text-align: right; position: absolute; bottom: 85px; right: 50px;">
            <img src="/images/logo.svg" alt="pibox logo" style="width: 80px; height: 80px; border-radius: 50%;" />
        </div>
    </div>`,
      "error",
      translate("close"),
      false,
      "",
      false,
      750
    )

  return (
    <LayoutLanding>
      {loading && <Loading />}

      <div className={classes.pqrs}>
        <Container maxWidth="sm" className="text-center">
          <Typography variant="h5" color="textPrimary">
            {translate("pqrs.title")}
          </Typography>
          <Typography variant="body2" color="textPrimary">
            {translate("pqrs.subtitle")}
          </Typography>
          <br />
          <br />
          <GuideNumberCheckForm
            submit={onSubmitGuideCheck}
            resetGuideNumber={resetGuideNumber}
            loadingGuideNumber={loadingGuideNumber}
          />
          <ContactForm
            submit={onSubmit}
            loading={loading}
            pqr
            isEnabled={isGuideValid}
          />
        </Container>
      </div>
      <Snackbar
        open={!!message}
        autoHideDuration={6000}
        onClose={() => closeMessage(dispatch, null)}
        message={translate(message)}
      />
    </LayoutLanding>
  )
}

export default withStyles(styles)(Pqrs)
